export type TLangCode = "ru" | "en" | "kg" | "tg" | "uz" | "kz";

export enum LANG_LABEL {
  RU = "Русский",
  EN = "English",
  KG = "Кыргыз тили",
  TG = "Тоҷикӣ",
  UZ = "O‘zbekcha",
}

export interface ILanguageOption {
  code: TLangCode;
  label: string;
  icon: string;
}
